import { createFormatters } from "app/infrastructure/data/date";

export enum AddImportSetModal {
  copyImportSetMappings = 'copyImportSetMappings'
}

export enum ImportSetFormIds {
  importDatabaseId = 'importDatabaseId',
  disabled = 'disabled',
  criteriaDomain = 'criteriaDomain',
  importConstraintSet = 'importConstraintSet',
  language = 'language'
}

export const languageValidationParameter = 'description';

export const maxDescriptionLength = 254;

export const duplicateTranslationSuffixNumber = 2;

export const duplicateSuffix = (locale: string) => createFormatters(locale).formatNumber(duplicateTranslationSuffixNumber, {});

export const textWithDuplicateSuffix = (text: string, locale: string) => `${text} (${duplicateSuffix(locale)})`;
